import auth from '@/plugins/auth'
import { constantRoutes } from '@/router'
import { userPermissionsList } from '@/api/systemManagement/userPermissions'
import Layout from '@/layout/index'

const permission = {
  state: {
    routes: [],
    addRoutes: [],
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        userPermissionsList({}).then(res => {
          const rdata = JSON.parse(JSON.stringify(res.data.menuAuthList))
          const rewriteRoutes = filterAsyncRouter(rdata, true)
          rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', rewriteRoutes)
          resolve(rewriteRoutes)
        })
      })
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(routes, type = false) {
  if (!routes) return
  const dealOptions = []
  // 给每个数据加children属性
  routes.forEach(one => {
    one.hidden ? one.hidden = false : one.hidden = true
    one.children = []
    one.meta = {
      title: one.title,
      icon: one.icon,
      permissions: one.buttonPermission,
      noCache: one.affix ? one.affix = true : one.affix = false
    }
  })
  routes.forEach(one => {
    if (one.component === 'Layout') {
      one.component = Layout
    } else {
      // 动态引入页面
      one.component = loadView(one.component)
    }
    const findIndex = routes.findIndex(item => {
      return item.id === one.pid
    })
    if ((!one.pid && one.pid !== 0 && one.pid !== false) || findIndex === -1) {
      dealOptions.push(one)
    } else {
      routes[findIndex].children.push(one)
    }
  })
  return dealOptions
  // return asyncRouterMap.filter(route => {
  //   if (type && route.children) {
  //     route.children = filterChildren(route.children)
  //   }
  //   if (route.component) {
  //     if (route.component === 'Layout') {
  //       route.component = Layout
  //     } else {
  //       route.component = loadView(route.component)
  //     }
  //   }
  //   if (route.children != null && route.children && route.children.length) {
  //     route.children = filterAsyncRouter(route.children, route, type)
  //   } else {
  //     delete route['children']
  //     delete route['redirect']
  //   }
  //   return true
  // })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (lastRouter) {
      el.path = lastRouter.path + '/' + el.path
    }
    children = children.concat(el)
  })
  return children
}

export const loadView = (view) => {
  if (process.env.NODE_ENV === 'development') {
    return (resolve) => require([`@/views${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views${view}`)
  }
}

export default permission
